module.exports = __webpack_public_path__ + "img/memo-circle-check.bd417d3a.svg";